module.exports = __webpack_public_path__ + "media/images/front/event/dummythumb2-aadac0460026661051a79392f6797151.svg";